import styled, { createGlobalStyle, css } from 'styled-components';
import { ThemeStyles } from 'src/commons/components/ChromeApp/ChromeAppUtils';
import { inkwell } from 'src/colors';
import { MOBILE_MENU_Z_INDEX } from 'src/commons/constants';

const marginStartMixin = css<{ shouldShiftAppWrapper: boolean }>`
  ${(props) =>
    props.shouldShiftAppWrapper ? 'margin-inline-start: 60px;' : ''}
`;
export const GlobalStyle = createGlobalStyle<{
  shouldShiftAppWrapper: boolean;
  isFromRodeo?: boolean;
  theme: ThemeStyles;
  isInterstitialPage?: boolean;
  isMobile?: boolean;
}>`
  html {
    height: 100vh;
    display: flex;
    flex-direction: column;
  }

  body {
    flex: 1;
    display: flex;
    flex-direction: column;
    font-family: "Amazon Ember", Arial, Helvetica, sans-serif;
    margin: 0;
    padding: 0;
    ${({ theme, isInterstitialPage = false, isMobile = false }) =>
      isInterstitialPage
        ? css`
            background-color: ${isMobile
              ? theme.palette.concrete
              : theme.palette.gray[25]};
          `
        : window.getComputedStyle(document.body).backgroundColor ===
            'rgba(0, 0, 0, 0)'
          ? css`
              background-color: ${theme.palette.white};
            `
          : null}
  }

  .chrome-wrapper {
    display: flex;
    flex-direction: column;
  }

  .app-and-pivot-wrapper {
    flex: 1;
    display: flex;
    flex-direction: ${({ shouldShiftAppWrapper }) =>
      shouldShiftAppWrapper ? 'row' : 'column'};
    ${marginStartMixin}
  }

  #PivotContainer {
    width: auto;
    ${({ shouldShiftAppWrapper }) =>
      shouldShiftAppWrapper
        ? css`
            height: 100%;
          `
        : css``};
  }

  #ChromeHeaderContainer {
    position: relative;
  }

  #MainMenuContainer {
    min-height: auto;
  }

  .app-body-wrapper {
    flex: 1;
    flex-direction: column;
    overflow: auto;
    ${({ isFromRodeo }) => (isFromRodeo ? 'padding: 14px 18px 18px;' : '')}
  }

  #app-content {
    flex: 1;
    flex-direction: column;
    overflow: auto;
    ${({ isFromRodeo }) => (isFromRodeo ? 'padding: 14px 18px 18px;' : '')}
  }

  #a-page {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  #sc-content-container {
    flex: 1;
  }

  .pivot-and-app-wrapper {
    flex: 1;
  }

  .sc-content-inner-container {
    display: flex;
    flex-direction: column;
    height: 100%;
  }
`;

export const MenuShiftWrapper = styled.div<{
  shouldShiftAppWrapper: boolean;
}>`
  ${marginStartMixin}
`;

export const HeaderContainer = styled.div`
  position: fixed;
  width: 100%;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.3);
  z-index: 399; // header should have most precedence
`;

export const MarketplaceSwitcherWrapper = styled.div<{
  isMobile: boolean;
  isFromTrim: boolean;
}>`
  :not(:empty) {
    background-color: ${({ theme }) => theme.header.pageHeader.background};
    padding: 8px 20px;
    margin: ${({ isMobile, isFromTrim }) =>
      isFromTrim && isMobile ? 0 : '0 0 2px'};
  }
`;

export const DesktopConsoleHeaderSection = styled.div`
  background: linear-gradient(
      90deg,
      rgba(255, 90, 0, 1) 0%,
      rgba(255, 132, 65, 1) 50%,
      rgba(255, 154, 115, 1) 100%
    )
    left bottom #777 no-repeat;
  background-size: 100% 3px;
  padding-bottom: 3px;
`;

export const LogoWrapper = styled.div`
  height: 26px;
  width: 106px;
  margin: 19px 18px 15px 20px;
  flex-shrink: 0;

  img {
    width: 100%;
    height: 100%;
  }
`;

export const MobileHeaderContainer = styled.div`
  display: block;
  position: fixed;
  top: 0;
  width: 100%;
  background-color: ${inkwell};
  z-index: ${MOBILE_MENU_Z_INDEX};
`;

export const StickyMobileHeader = styled.div`
  position: fixed;
  width: 100%;
  z-index: ${MOBILE_MENU_Z_INDEX};
`;

export const EmptyContextBar = styled.div`
  flex-grow: 1;
`;
